export default {
  BusinessStockDistributionPlanView: {
    title: 'Account Information',
    code: 'Plan Number',
    receiveWarehouseId: 'Receiving Warehouse',
    selectTime: 'Please select a start time first',
    priority: 'Priority',
    commodityDetails: 'Product Details',
    addingGoods: 'Add Product',
    delGoods: 'Delete Product',
    text: 'When the receiving warehouse is a virtual warehouse and there is a shortage, the allocation of shortage orders will be displayed',
    backorderAllocation: 'Backordered orders allocation',
    receiveWarehouseText: 'Please select receiving warehouse',
    startDateText: 'Please select start date',
    priorityGrade: 'Please enter priority',
    msgSuccess: 'Deletion successful',
    msgWarning: 'Planned supply quantity cannot be less than 1',
    confirmText1: 'Whether to review',
    confirmText2: 'Approved',
    confirmText3: 'Not Approved',
    confirmText4: 'this data?',
    confirmText5: 'Are you sure you want to delete the selected data in batch?',

    table: {
      inStockNum: 'Receiving Warehouse Inventory',
      inStockUsableNum: 'Receiving Warehouse Available Inventory',
      stockOutNum: 'Receiving Warehouse Out-of-Stock Quantity',
      planNum: 'Planned Supply Quantity',
      priorityReplenishStatus: 'Whether to prioritize replenishing out-of-stock orders'
    }

  }
};
